module.exports = __webpack_public_path__ + "img/wheelBanner.07e3798f.png";